import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=7c466df8&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=7c466df8&prod&lang=scss&scoped=true"
import style1 from "./Inbox.vue?vue&type=style&index=1&id=7c466df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c466df8",
  null
  
)

export default component.exports